import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { LossAndDamageClaimFileAttachment } from '../../types';

export interface GetLADClaimFilesRequestParams {
  claimKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface LADClaimFilesResponse {
  data: LossAndDamageClaimFileAttachment[];
  totalRows: number;
}

export const getLADClaimFilesAPI = (params: GetLADClaimFilesRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      claimKey: params.claimKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || 10,
      sortColumn: params.sortColumn || 'sequence',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimFile`,
  });
};

export const fetchLADClaimFiles = async (params: GetLADClaimFilesRequestParams): Promise<LADClaimFilesResponse> => {
  const response: AxiosResponse<LADClaimFilesResponse> = await getLADClaimFilesAPI(params);
  return response.data;
};
